/**
 * @license
 * Copyright Google Inc. All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.io/license
 */

export {DOMTestComponentRenderer as ÉµDOMTestComponentRenderer} from './dom_test_component_renderer';
export {platformCoreDynamicTesting as ÉµplatformCoreDynamicTesting} from './platform_core_dynamic_testing';
